import axios from 'axios';

// CBDCE OpenAPI Spec - https://www.cbdce.qa.3whst.com/o/cbdce-headless/v1.0/openapi.yaml

class Services {
    constructor(baseUrl = null, apiVersion = null, contentType = null) {
        axios.defaults.headers.post['Content-Type'] = contentType
            ? contentType
            : 'application/json';

        this.baseUrl = baseUrl ? baseUrl : 'https://www.cbdce.qa.3whst.com';
        this.apiVersion = apiVersion ? apiVersion : '/o/cbdce-headless/v1.0';
        this.url = this.baseUrl + this.apiVersion;
    }

    async sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async initSearchOptions() {
        const requestUrl = `${this.url}/init-search-options`;
        let res;
        try {
            res = await axios.get(requestUrl);
        } catch (e) {
            console.log(e);
            res = false;
        } finally {
            if (res && res.status === 200 && res.data) {
                return res.data;
            } else {
                return {};
            }
        }
    }

    async searchProfiles(
        lat = null,
        lng = null,
        radius = null,
        populationsServed = [],
        focusAreas = [],
        languagesSpoken = [],
        serviceModalities = [],
        lastName = null,
        page = 1,
        pageSize = 50
    ) {

        let queryStr = `?page=${page}&pageSize=${pageSize}`;
        if (focusAreas && focusAreas.length) {
            queryStr += `&focusAreas=${focusAreas.join()}`;
        }
        if (populationsServed && populationsServed.length) {
            queryStr += `&populationsServed=${populationsServed.join()}`;
        }
        if (languagesSpoken && languagesSpoken.length) {
            queryStr += `&languagesSpoken=${languagesSpoken.join()}`;
        }

        if (serviceModalities && serviceModalities.length) {
            queryStr += `&serviceModalities=${serviceModalities.join()}`;
        }

        if (lat != null && lng != null && radius != null) {
            queryStr += `&lat=${lat}&lng=${lng}&radius=${radius}`;
        }
        if (lastName) {
            queryStr += `&lastName=${lastName}`;
        }
        const requestUrl = `${this.url}/member-public-profiles/${queryStr}`;
        let res;

        try {
            res = await axios.get(requestUrl);
        } catch (e) {
            console.log(e);
            res = false;
        } finally {
            if (res && res.data.items !== undefined) {
                await this.sleep(1000);
                return res.data;
            } else {
                return { items: [], ...res.data }; // API is not returning an empty array of items.
            }
        }
    }
}
const baseUrl = (typeof window.Liferay !== 'undefined' && window.Liferay.ThemeDisplay.getPortalURL()) || 'https://www.cbdce.qa.3whst.com';

const API = new Services(baseUrl);
export default API;
